import { Box, Typography } from '@mui/material';
import React from 'react';

function Footer() {
  return (
    <Box
      sx={(theme) => ({
        [theme.breakpoints.up('sm')]: {
          position: 'fixed',
          bottom: 0,
          background: '#eaeff1',
          padding: theme.spacing(1),
          height: 15,
          width: '100%',
          zIndex: 9,
        },
        display: 'flex',
        justifyContent: 'center',
      })}
    >
      <Typography
        variant="body2"
        color={'textSecondary'}
        align="center"
        sx={{
          mr: 2,
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline',
            color: 'primary.main',
          },
        }}
        onClick={() => {
          // navigate to privacy policy page
          window.open(process.env.REACT_APP_PRIVACY_POLICY_URL, '_blank');
        }}
      >
        Privacy Policy
      </Typography>
      <Typography variant="body2" color={'textSecondary'} align="center">
        {' | '}
      </Typography>
      <Typography
        variant="body2"
        color={'textSecondary'}
        align="center"
        sx={{ ml: 2 }}
      >
        {'Copyright © Kmart  '}
        {new Date().getFullYear()}
      </Typography>
    </Box>
  );
}

export default Footer;
